import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as AuctionActions from './auction.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const auctionFeatureKey = 'auction';

export interface State extends EntityState<any>{
    component: string | { name: string, payload: any };
    currentAuctionItem:any;
    currentAuctionItemCategoty:any[]
    currentAuctionCampaign:any;
    currentBiActivity: any[];
    currentPendingDonations: any[];
    currentPaidDonations: any[];
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
    component: {
      name: 'auction-campaign-list',
      payload: {}
    },
    currentAuctionItem:null,
    currentAuctionItemCategoty:[],
    currentAuctionCampaign:null,
    currentBiActivity: [],
    currentPendingDonations: [],
    currentPaidDonations: [],
});

export const reducer = createReducer(
    initialState,

    on(AuctionActions.loadAuction, state => state),
    on(AuctionActions.loadAuctionSuccess, (state, {data: currentAuctionCampaign}) => {
        return {
            ...state,
            currentAuctionCampaign
        }
    }),
    on(AuctionActions.loadAuctionFailure, (state, action) => state),
    

    on(AuctionActions.loadItemDetailInfo, state => state),
    on(AuctionActions.loadItemDetailInfoSuccess, (state, {data}) => {
        let currentAuctionItem = data
        return {
        ...state,
        currentAuctionItem
        }
    }),
    on(AuctionActions.loadItemDetailInfoFailure, (state, action) => state),


    on(AuctionActions.saveCategory, (state, action:any) => {
        let currentAuctionItemCategoty = action.payload
        return {
          ...state,
          currentAuctionItemCategoty
        }
    }),

    on(AuctionActions.loadBidActivySuccess, (state,action) => {
        return {
            ...state,
            currentBiActivity: action.bidActivityList,
        }
    }),

    on(AuctionActions.loadPendingDonationsSuccess, (state,action) => {
        return {
            ...state,
            currentPendingDonations: action.pendingDonations,
        }
    }),

    on(AuctionActions.loadPaidDonationsSuccess, (state,action) => {
        return {
            ...state,
            currentPaidDonations: action.paidDonations,
        }
    })
)